export const galleryPhotos = [
    {
        id: 1,
        src: '/images/officedoor.JPG',
        alt: 'Gallery photo 1',
    },
    {
        id: 2,
        src: '/images/chrisoffice1.jpeg',
        alt: 'Gallery photo 2',
    },
    {
        id: 3,
        src: '/images/chrisoffice2.jpeg',
        alt: 'Gallery photo 3',
    },
    {
        id: 4,
        src: '/images/chrisoffice3.JPG',
        alt: 'Gallery photo 4',
    },
    {
        id: 5,
        src: '/images/chrisoffice4.JPG',
        alt: 'Gallery photo 5',
    },
];
